import {IGameLimitsExternalLinkHandler} from "./game-limits.external-link-handler.interface";
import {ControlCenterDeeplink} from "@sparkware/uc-sdk-core";
import {CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {ExternalLinkHandlerBase} from "../external-link-handler-base";
import {IOpenGameLimitsOptions} from "../../external-links.service.interface";
import {MyAccountTab} from "@sparkware/uc-sdk-core";

export class GameLimitsExternalLinkHandler extends ExternalLinkHandlerBase implements IGameLimitsExternalLinkHandler{
    async openGameLimits(options:IOpenGameLimitsOptions): Promise<void> {
        if(this.services.abTestingFeatureDataProvider.controlCenter.isEnabled) {
            await (await this.services.appLauncher).openControlCenterFull({
                businessCorrelationID: this.services.tools.getGuid(),
                channel: {
                    area: options.channelArea,
                    element: options.channelElement,
                    source: CHANNEL_SOURCE.casinoClient
                },
                appSpecificParameters: {
                    deeplink: ControlCenterDeeplink.Main,
                    source: options.source
                }
            });
        }else
        {
            await (await this.services.externalLinks).openMyAccount({
                tabId: MyAccountTab.ResponsibleGaming
            });
        }

    }
}